export default __webpack_public_path__ + "static/media/barra.b9399333.png";